import { render, staticRenderFns } from "./BindComp.vue?vue&type=template&id=ca10b45c&scoped=true&"
import script from "./BindComp.vue?vue&type=script&lang=js&"
export * from "./BindComp.vue?vue&type=script&lang=js&"
import style0 from "./BindComp.vue?vue&type=style&index=0&id=ca10b45c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca10b45c",
  null
  
)

export default component.exports